const MAX_FIRST_NAME = 17;
const MAX_LAST_NAME = 22;

export const navigateToCAMDashboard = {
    mobile: '/account/dashboard',
    desktop: '/account/dashboard',
};

export const paymentMethodTypeIconMap = {
    'AMERICAN EXPRESS': 'american-express.svg',
    DISCOVER: 'discover.svg',
    AMEX: 'american-express.svg',
    'JCPENNEY MASTERCARD': 'jcpmastercard.svg',
    JCP: 'jcp-plcc.svg',
    'MASTER CARD': 'mastercard.svg',
    MASTERCARD: 'mastercard.svg',
    PAYPAL: 'paypal.svg',
    VISA: 'visa.svg',
    DUALCARD: 'jcpmastercard.svg',
    DEFAULT: 'neutral.svg',
};

export const orderDetailsFetch = {
    cardTypeMap: {
        AMEX: 'AMERICAN_EXPRESS',
        DISCOVER: 'DISCOVER',
        JCP: 'JCP_CARD',
        JCPMASTER: 'JCPENNY_MASTER_CARD',
        MASTER: 'MASTER_CARD',
        VISA: 'VISA',
    },
    emailableCarePlanSubDivisions: ['090', '117', '209', '683', '780', '864', '869', '076'],
    mailableCarePlanSubDivisions: ['098'],
    deliveryPromiseMessageDescription: {
        'Pickup Interval': 'Pickup: % s - % s',
        'Est Delivery Interval': 'Est.Delivery: % s - % s',
        'Est Delivery Date': 'Est.Delivery: % s',
        'Selected Delivery Date': 'Selected Delivery Date: % s',
        'Pickup Soon': 'THESE ITEMS WILL BE AVAILABLE FOR PICK UP IN 4 TO 7 BUSINESS DAYS.',
        'Email Care Plan': 'Care plan provider will email protection plan(s)',
        'Mail Protection Plan': 'Care plan provider will mail protection plan(s) to the address',
    },
    deliveryPromiseStatus: {
        Backordered: 'Backordered',
        Cancelled: 'Canceled',
        Delivered: 'Delivered',
        'In Process': 'In Progress',
        'In process': 'In Progress',
        'Transfer in Process': 'In Progress',
        'Pending fulfillment': 'In Progress',
        'Released to Fulfillment': 'In Progress',
        Picked: 'In Progress',
        Packed: 'In Progress',
        Shipped: 'Shipped',
        'Ready for Customer Pick': 'Ready for Pickup',
        'Picked by Customer': 'Picked Up',
        'Return Created': 'Returned',
        'Shipped to Store': 'Shipped to Store',
        'Post Invoice Cancel': 'Canceled',
        'Picked up Date': 'Picked Up: % s',
        'Picked up': 'Picked Up',
        'In Progress': 'In Progress',
        Returned: 'Returned',
        'Ready for Pickup': 'Ready for Pickup',
    },
    backOrderItemStatus: ['Back Order', 'BO WOH', 'Backordered'],
    cancelledItemStatus: ['Back Order Cancel', 'Canceled', 'Cancelled'],
    notAvailableItemStatus: [
        'Not Available',
        'Partial Available',
        'Partial Back Order',
        'Partial Discontinue',
        'Partial Track Order',
        'TO',
        'Discontinued',
        'No Process',
        'Dropped',
        'TO Recorder',
        'Back Order Delete',
        'Error',
    ],
    factoryShipItemStatus: [
        'Factory Ship Supplier Cancel',
        'Factroy Ship Customer Cancel',
        'Factory Ship Release',
        'Factory Ship',
    ],
    largeApplianceItems: [
        'largeAppliance',
        'LARGEAPPLIANCEINSTALL',
        'LARGEAPPLIANCESERVICE',
        'LARGEAPPLIANCEPARTS',
    ],
    protectionPlanAndServiceItems: ['SERVICE', 'LARGEAPPLIANCEINSTALL', 'LARGEAPPLIANCEPARTS'],
    priceTypes: ['PRICEQUOTE', 'ORIGINAL', 'ACTIVE', 'CLEARANCE', 'SALE', 'FORCEDPRICE'],
    chargeTypes: [
        'TAX',
        'OVERSIZED SURCHARGE',
        'SHIPPING AND HANDLING',
        'GIFTWRAP',
        'RECYCLE CHARGE',
        'ROUND UP CHARITY',
    ],
    discountTypes: [
        'COUPON',
        'REWARDSCERT',
        'ENTERPRISE',
        'ASSOCIATEDISCOUNT',
        'SHIPPING',
        'MISCELLANEOUS',
    ],
    roundupCharityLotNumbers: ['1712000'],
    recycleFeeLotNumbers: ['713'],
    retailDeliveryFeeLotNumbers: ['24601000018'],
};

export const navigateToSignIn = {
    mobile: '/signin',
    desktop: '/signin',
};

export const navigateToHome = {
    mobile: '/',
    desktop: '/',
};

export const createAccount = {
    name: /^[a-zA-Z\s0-9]*$/,
    upperCharRegExp: /[A-Z]/,
    lowerCharRegExp: /[a-z]/,
    numberRegExp: /\d/,
    birthday: /^[0-9/]{1,5}$/,
    phoneNumber: /^\d{10}$/,
    phoneNumberRegx: /^[0-9]*$/,
    birthdayRegx: /^(((0)[1-9])|((1)[0-2]))(\/)((0)[1-9]|[1-2][0-9]|(3)[0-1])$/,
    maxFirstName: MAX_FIRST_NAME,
    maxLastName: MAX_LAST_NAME,
    moreThanTwoConsecutiveCharsRegExp: /(.)\1\1/,
    firstNameRegx: /^(?!.*([A-Za-z0-9À-ÖØ-öø-ÿ ])\1{2})(?=.*[a-zA-ZÀ-ÖØ-öø-ÿ])[A-Za-z0-9À-ÖØ-öø-ÿ,. -]{1,17}$/,
    lastNameRegx: /^(?!.*([A-Za-z0-9À-ÖØ-öø-ÿ ])\1{3})(?=.*[a-zA-ZÀ-ÖØ-öø-ÿ])[A-Za-z0-9À-ÖØ-öø-ÿ,. -]{2,22}$/,
    // specialCharsRegExp: /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/,
    invalidPhoneNumber: 'Please enter a valid phone number',
    infoIconName: 'information',
    loyaltyInValidTokenErrorCode: 'LOYALTY_INVALID_TOKEN',
};
export const signin = {
    emailRegExp: /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9]+)*@[A-Za-z0-9]+([_.][A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
    emptyEmailErrorMessage: 'Please enter a valid email address',
    longEmailErrorMessage: 'Email should contain not more than 70 characters.',
    emptyPasswordErrorMessage: 'Enter a valid password',
    captchaErrorType: 'ERROR_TYPE_CAPTCHA',
    captchaNotChecked: 'Enter captcha',
    errorTypeEmail: 'ERROR_TYPE_EMAIL',
    errorTypePassword: 'ERROR_TYPE_PASSWORD',
    errorTypeEmailAndPassword: 'ERROR_TYPE_EMAIL_PASSWORD',
    generalErrorMessage: 'Please correct the errors listed in red below',
    rememberMeExpireDays: 365,
    jcpSigninCookie: 'JCPSignInCookie',
    svcUsrErrProfileLocked: 'SVC_USR_ERR_PROFILE_LOCKED',
    srvProfileLocked: 'SRV_PROFILE_LOCKED',
    profileLockedErrorMessage:
        'You have reached the max number of login attempts. For your protection, this jcp.com account has been locked. You will receive an email shortly to reset your password.',
    srvCustomerNotFound: 'SRV_CUSTOMER_NOTFOUND',
    srvCustomerNotFoundMessage:
        'The email address or password you entered was not found in our records. Remember, your password is case sensitive. Please try again.',
    errCodeLastAttempt: 'SVC_USR_ERR_PROFILE_ACCOUNT_LAST_ATTEMPT',
    srvCaptchaNotFound: 'SRV_INVALID_CAPTCHA_REQUEST',
    srvCaptchaInvalid: 'SRV_GC_CAPTCHA_INVALID',
    srvCaptchaNotFoundMessage:
        'You have only one more attempt to login before the account gets locked.',
    requestFailedMessage: 'We’re having trouble completing your request. Try again.',
};
export const placeholder = {
    password: 'Password',
    newPassword: 'New Password',
};
export const termsAndConditionsLink =
    'http://www.jcpenney.com/m/rewards-terms-and-conditions?pageId=pg40067700009';
export const DP_USER_STATE = 'DP_USER_STATE';
export const DP_REWARDS_CERTS = 'DP_REWARDS_CERTS';
const Constants = {
    barcode: {
        modalTitle: 'Use Your Rewards',
        modalHeading:
            'To Redeem in-store, present barcode to the cashier. Some <a href="www.jcpenney.com">exclusions</a> may apply.',
        modalButtonTitle: 'Print',
        type: {
            JCPMASTER: ['MCCERT', 'MASTERCARD RWD'],
        },
        images: {
            MASTERCARD: '/static-account/assets/images/mc-vrt-pos.svg',
            BONUSBUCKS: '/static-account/assets/images/bonus-bucks-cert-header.svg',
            BG_LG_BONUSBUCKS: '/static-account/assets/images/bonus-bucks-bg-xl.svg',
        },
    },
    navigateToRewardsHome: {
        mobile: '/rewards',
        desktop: '/rewards',
    },

    cardTypeMap: {
        amex: /^3[47]|^3([8]{10})|^3([9]{10})/,
        visa: /^(4[0-9]).{10}.*$/,
        discover: /^(?:6(?:011|5[0-9][0-9]|4[4-9])[0-9]{8})|^6[8]{10}|^6[9]{10}.*$/,
        dualcard: /(^546680.{6}|^(78|79).{10}).*$/,
        jcpmaster: /(^546680.{6}|^(78|79).{10}).*$/,
        mastercard: /^(5[1-5]).{10}|^5([8]{10})|^5([9]{10}).*$/,
        jcp: /^\d{11}$|^\d{16}$/,
    },
    impulseCardTypeMap: {
        'AMERICAN EXPRESS': /^3[47]|^3([8]{10})|^3([9]{10})/,
        VISA: /^(4[0-9]).{10}.*$/,
        DISCOVER: /^(?:6(?:011|5[0-9][0-9]|4[4-9])[0-9]{8})|^6[8]{10}|^6[9]{10}.*$/,
        'JCPENNEY MASTERCARD': /(^546680.{6}|^(78|79).{10}).*$/,
        'MASTER CARD': /^(5[1-5]).{10}|^5([8]{10})|^5([9]{10}).*$/,
        JCP: /^\d{11}$|^\d{16}$/,
    },
    ACCOUNT_ID: 'ACCOUNT_ID',
    DP_FIRST_NAME: 'DP_FIRST_NAME',
    DP_REWARDS_STATUS: 'DP_REWARDS_STATUS',
    cvv: {
        label: 'CVN',
    },

    confirmCreateAccount: {
        title: 'Confirm Your Account',
        message: 'A confirmation email has been sent to ',
        spamCheckMsg: 'Make sure to check your spam folder.',
    },
    keepMeLoggedIn: {
        title: 'Keep me signed in',
        helpMessage: 'Uncheck the box if this is a shared device.',
    },

    navigateToCreateAccount: {
        mobile: '/createaccount',
        desktop: '/createaccount',
    },
    trackOrder: {
        inputFields: {
            orderNumber: {
                defaultError: 'Please enter a valid order number',
                label: 'Order Number',
                type: 'text',
                name: 'orderNumber',
                onlyNum: /[^\d]/g,
            },
            phoneNumber: {
                defaultError: 'Please enter a valid phone number',
                label: 'Phone Number',
                placeholder: '( ___ ) ___ - ____ ',
                name: 'phoneNumber',
            },
        },
    },
};

export default Constants;
